import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { forgotPassword } from '../../services/authService';
import Button from '../../components/common/Button/Button';
import cosmicLogo from '../../assets/images/cosmic-logo.png';
import styles from './Login.module.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await forgotPassword(email);
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.detail || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.loginContainer}>
      <div className={styles.loginCard}>
        <div className={styles.header}>
          <img src={cosmicLogo} alt="COSMIC Logo" className={styles.logoImage} />
          <h1 className={styles.logo}>COSMIC</h1>
          <p className={styles.subtitle}>Reset your password</p>
        </div>

        {sent ? (
          <div className={styles.form}>
            <p style={{ textAlign: 'center', color: '#555', fontSize: '14px', lineHeight: 1.6 }}>
              If <strong>{email}</strong> is registered, a password reset link is on its way.
              The link expires in an hour and can only be used once.
            </p>
            <p style={{ textAlign: 'center', color: '#777', fontSize: '12px', marginTop: '12px' }}>
              Didn't get it? Check your spam folder, or{' '}
              <button
                type="button"
                onClick={() => setSent(false)}
                style={{
                  background: 'none', border: 'none', color: '#4a90e2',
                  cursor: 'pointer', padding: 0, fontSize: '12px', textDecoration: 'underline'
                }}
              >
                try another address
              </button>.
            </p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className={styles.form}>
            <p style={{ color: '#555', fontSize: '14px', marginBottom: '16px', lineHeight: 1.6 }}>
              Enter the email address on your account and we'll send you a link to set a new password.
            </p>

            <div className={styles.formGroup}>
              <label htmlFor="email" className={styles.label}>Email</label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className={styles.input}
                placeholder="Enter your email"
                required
              />
            </div>

            {error && <div className={styles.error}>{error}</div>}

            <Button type="submit" variant="primary" fullWidth loading={loading} disabled={loading}>
              {loading ? 'Sending...' : 'Send Reset Link'}
            </Button>
          </form>
        )}

        <div className={styles.footer}>
          <p>
            <Link to="/login" style={{ color: '#4a90e2' }}>Back to login</Link>
          </p>
          <p style={{ marginTop: '10px' }}>© 2025 CreatED. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
